import React, { FC } from "react";
import Image from "next/image";
import { StyledImageWrapper } from "./index.styled";
import { getCloudflareLoader } from "../../helpers/cloudflareImages";

import getConfig from "next/config";

const { publicRuntimeConfig } = getConfig();

interface ImageAndQuantityProps {
  alt: string;
  size: number;
  src: string;
}

/**
 * Fits a product image with unknown height/width into a square
 * with height/width of size prop in pixels
 */
export const ProductImage: FC<ImageAndQuantityProps> = ({
  alt,
  size,
  src = "",
}) => (
  <StyledImageWrapper size={size}>
    <Image
      alt={alt}
      src={src}
      loader={getCloudflareLoader(publicRuntimeConfig.productsImgCdn)}
      fill
      // double width for retina screens
      sizes={`${size * 2}px`}
      style={{
        objectFit: "contain",
      }}
    />
  </StyledImageWrapper>
);
